import { createContext as e, useContext as t } from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/form-control-size/index.tsx
var r = e(void 0);
function i({ children: e, size: t }) {
	return /* @__PURE__ */ n(r.Provider, {
		value: t,
		children: e
	});
}
var a = () => t(r);
//#endregion
export { i as FormControlSizeProvider, a as useFormControlSize };
